import Vue from "vue";
import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import VueMarkdown from "vue-markdown";
import VueLottiePlayer from "vue-lottie-player";
import axios from "axios";
import VueAxios from "vue-axios";
import Vuex from "vuex";
// import VueI18n from 'vue-i18n'
// import pl from '@/locale/pl.json'
// import en from '@/locale/en.json'

import storeModule from "./store";
import { setupInterceptors } from "./utils/httpInterceptors";

Vue.use(Vuex);
const store = new Vuex.Store(storeModule);

// import darkTheme from '@ant-design/dark-theme';

const moment = require("moment");
require("moment/locale/pl");

Vue.use(require("vue-moment"), {
    moment,
});

// const messages = {
//     pl, en
// }

// const i18n = new VueI18n({
//     locale: 'pl',
//     messages
// })

Vue.config.productionTip = false;
Vue.use(Antd, VueMarkdown, VueLottiePlayer, VueAxios, axios);

new Vue({
    router,
    store,
    // i18n,
    render: (h) => h(App), created() {
        setupInterceptors(store);
    },
}).$mount("#app");
